export enum ADMISSION_STATUS {
    DRAFT = 'DRAFT',
    WAITING_FOR_VERIFICATION = 'WAITING_FOR_VERIFICATION',
    VERIFIED = 'VERIFIED',
    REJECTED = 'REJECTED',
    WAITING_FOR_TUITION_PAYMENT = 'WAITING_FOR_TUITION_PAYMENT',
    WAITING_FOR_VERIFICATION_TUITION_PAYMENT = 'WAITING_FOR_VERIFICATION_TUITION_PAYMENT',
    TUITION_PAYMENT_SUCCESS= 'TUITION_PAYMENT_SUCCESS',
    TUITION_PAYMENT_REVIEW= 'TUITION_PAYMENT_REVIEW',
    WAITING_FOR_INTERVIEW = 'WAITING_FOR_INTERVIEW',
    INTERVIEW_SUCCESS = 'INTERVIEW_SUCCESS',
    INTERVIEW_FAILED = 'INTERVIEW_FAILED',
    PASSED_THE_EXAM = 'PASSED_THE_EXAM',
    FAILED_THE_EXAM = 'FAILED_THE_EXAM',
    WAITING_FOR_EXAM = 'WAITING_FOR_EXAM',
    ACCEPTED_STUDENT = 'ACCEPTED_STUDENT',
    STUDYING = 'STUDYING',
    PASS = 'PASS',
    FINISH_STUDYING = 'FINISH_STUDYING',
    NO_LONGER_STUDENT = 'NO_LONGER_STUDENT',
    RESIGN = 'RESIGN',
    STUDENT_SUSPENSION = 'STUDENT_SUSPENSION',
}
export const status_admission: {
  label: string;
  value: string;
}[] = [
  {
    label: "บันทึกร่าง",
    value: ADMISSION_STATUS.DRAFT,
  },
  {
    label: "รอตรวจสอบ",
    value: ADMISSION_STATUS.WAITING_FOR_VERIFICATION,
  },
  {
    label: "รอกำหนดแจ้งการสอบ",
    value: ADMISSION_STATUS.VERIFIED,
  },
  {
    label: "ไม่ผ่านการพิจารณา",
    value: ADMISSION_STATUS.REJECTED,
  },
  {
    label: "รอการชำระเงินค่าเทอม",
    value: ADMISSION_STATUS.WAITING_FOR_TUITION_PAYMENT,
  },
  {
    label: "รอการตรวจสอบยอดเงิน",
    value: ADMISSION_STATUS.WAITING_FOR_VERIFICATION_TUITION_PAYMENT,
  },
  {
    label: "ตรวจสอบยอดเงินแล้ว",
    value: ADMISSION_STATUS.TUITION_PAYMENT_SUCCESS,
  },
  {
    label: "ส่งทบทวนยอดเงิน",
    value: ADMISSION_STATUS.TUITION_PAYMENT_REVIEW,
  },
  {
    label: "รอผลสอบสัมภาษณ์",
    value: ADMISSION_STATUS.WAITING_FOR_INTERVIEW,
  },
  {
    label: "ผ่านสอบสัมภาษณ์",
    value: ADMISSION_STATUS.INTERVIEW_SUCCESS,
  },
  {
    label: "ไม่ผ่านสอบสัมภาษณ์",
    value: ADMISSION_STATUS.INTERVIEW_FAILED,
  },
  {
    label: "ผ่านการสอบ",
    value: ADMISSION_STATUS.PASSED_THE_EXAM,
  },
  // {
  //   label: "ผ่านการสอบ",
  //   value: ADMISSION_STATUS.PASSED_THE_EXAM,
  // },
  {
    label: "ไม่ผ่านการสอบ",
    value: ADMISSION_STATUS.FAILED_THE_EXAM,
  },
  {
    label: "รอการสอบ",
    value: ADMISSION_STATUS.WAITING_FOR_EXAM,
  },
  {
    label: "ยืนยันนักศึกษา",
    value: ADMISSION_STATUS.ACCEPTED_STUDENT,
  },
  {
    label: "กำลังศึกษา",
    value: ADMISSION_STATUS.STUDYING,
  },
  {
    label: "ผ่าน",
    value: ADMISSION_STATUS.PASS,
  },
  {
    label: "จบการศึกษา",
    value: ADMISSION_STATUS.FINISH_STUDYING,
  },
  {
    label: "จบการศึกษา",
    value: ADMISSION_STATUS.NO_LONGER_STUDENT,
  },
  {
    label: "พ้นสภาพ",
    value: ADMISSION_STATUS.NO_LONGER_STUDENT,
  },
  {
    label: "ลาออก",
    value: ADMISSION_STATUS.RESIGN,
  },
  {
    label: "พักการเรียน",
    value: ADMISSION_STATUS.STUDENT_SUSPENSION,
  },

]
export const status_admission_en: {
  label: string;
  value: string;
}[] = [
  {
  label: "Save Draft",
  value: ADMISSION_STATUS.DRAFT,
},
{
  label: "Pending Verification",
  value: ADMISSION_STATUS.WAITING_FOR_VERIFICATION,
},
{
  label: "Pending Exam Notification",
  value: ADMISSION_STATUS.VERIFIED,
},
{
  label: "Rejected",
  value: ADMISSION_STATUS.REJECTED,
},
{
  label: "Pending Tuition Payment",
  value: ADMISSION_STATUS.WAITING_FOR_TUITION_PAYMENT,
},
{
  label: "Pending Payment Verification",
  value: ADMISSION_STATUS.WAITING_FOR_VERIFICATION_TUITION_PAYMENT,
},
{
  label: "Payment Verified",
  value: ADMISSION_STATUS.TUITION_PAYMENT_SUCCESS,
},
{
  label: "Payment Review Requested",
  value: ADMISSION_STATUS.TUITION_PAYMENT_REVIEW,
},
{
  label: "Waiting for Interview Result",
  value: ADMISSION_STATUS.WAITING_FOR_INTERVIEW,
},
{
  label: "Interview Passed",
  value: ADMISSION_STATUS.INTERVIEW_SUCCESS,
},
{
  label: "Interview Failed",
  value: ADMISSION_STATUS.INTERVIEW_FAILED,
},
{
  label: "Exam Passed",
  value: ADMISSION_STATUS.PASSED_THE_EXAM,
},
{
  label: "Exam Failed",
  value: ADMISSION_STATUS.FAILED_THE_EXAM,
},
{
  label: "Awaiting Examination",
  value: ADMISSION_STATUS.WAITING_FOR_EXAM,
},
{
  label: "Student Confirmed",
  value: ADMISSION_STATUS.ACCEPTED_STUDENT,
},
{
  label: "Currently Studying",
  value: ADMISSION_STATUS.STUDYING,
},
{
  label: "Passed",
  value: ADMISSION_STATUS.PASS,
},

]
export const renderStatus = (value: string): string => {
  return (
    status_admission.find((x) => x.value === value)?.label ||
    status_admission.find((x) => x.value.split(",").includes(value))
      ?.label ||
    ""
  );
};

export const renderStatusEn = (value: string): string => {
  return (
    status_admission_en.find((x) => x.value === value)?.label ||
    status_admission_en.find((x) => x.value.split(",").includes(value))
      ?.label ||
    ""
  );
};


